export default "/images/download.svg?b47c418b3c6e316d65e775a0609a5f52";